module.exports = __webpack_public_path__ + "static/media/image.59be16ca.svg";